var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "17", viewBox: "0 0 24 17", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "hamburger"
    ),
    React.createElement(
      "g",
      { stroke: "#979797", strokeWidth: "4", fill: "none", fillRule: "evenodd", strokeLinecap: "square" },
      React.createElement("path", { d: "M2.475 14.816h19.287M2.475 2.184h19.287" })
    )
  );
});